<div>
  <p-select
    [options]="(taskList$ | async) ?? []"
    [(ngModel)]="currentTask"
    (onChange)="onTaskSelected($any($event).value)"
    (onClear)="onTaskSelected(null)"
    placeholder="Select task"
    [filter]="true"
    filterBy="number,name"
    [showClear]="true"
    appendTo="body"
    styleClass="task-selector-select"
    panelStyleClass="task-selector-panel"
    aria-label="Task selector"
  >
    <ng-template let-task pTemplate="selectedItem">
      <span class="task-selector-value">{{ displayValue(task) }}</span>
    </ng-template>
    <ng-template let-task pTemplate="item">
      <span class="task-selector-option">{{ displayValue(task) }}</span>
    </ng-template>
  </p-select>
</div>
